module.exports = __webpack_public_path__ + "assets/img/3_1207_big.02174e4d.jpg";